import React, { useEffect } from 'react';
import '../styles/CaseStudyDetail.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';
const CaseStudy2 = () => {

    useEffect(() => {
        document.title = "Building a Trusted Data Foundation for Financial Services | Datamatics Consulting";
    }, []);
    return (
        <div className="cs-page">

            {/* Hero */}
            <section className="cs-hero">
                <div className="cs-hero-overlay">
                    <span className="cs-sector-badge">Investment & Financial Services</span>
                    <h1>Building a Trusted Data Foundation for Financial Services</h1>
                    <p>An investment leader reduced integration costs, improved analytics delivery, and achieved zero audit findings by deploying a governance-first data ecosystem.</p>
                </div>
            </section>

            {/* Body */}
            <section className="cs-body container">
                <div className="cs-section">
                    <div className="cs-label">Challenge</div>
                    <div className="cs-content">
                        <p>A major financial institution was hindered by fragmented data spread across multiple systems. Compliance processes were slow, analytics were unreliable, and integration costs kept rising. The result: missed opportunities for faster decision-making, higher operating expenses, and increased regulatory risk.</p>
                    </div>
                </div>
                <div className="cs-divider" />
                <div className="cs-section">
                    <div className="cs-label">Our Approach & Solution</div>
                    <div className="cs-content">
                        <p>Datamatics worked closely with the institution's compliance and technology leaders to design a unified data strategy. Instead of piecemeal fixes, we aimed to create a foundation that would lower costs, speed up analytics, and satisfy the most rigorous audit requirements.</p>
                        <p>We helped establish a <strong>Data Management Office (DMO)</strong> to set governance and operating standards. On the technology side, we deployed <strong>Informatica's Intelligent Data Management Cloud (IDMC)</strong>, <strong>Master Data Management (MDM)</strong>, and <strong>Customer 360 (C360)</strong> to create a trusted, scalable data ecosystem. This not only streamlined integration but also prepared the institution for AI and ML adoption at scale.</p>
                    </div>
                </div>
            </section>

            {/* Results */}
            <section className="cs-results">
                <h2>Results</h2>
                <div className="cs-results-grid">
                    <div className="cs-stat">
                        <span className="cs-stat-number">30%</span>
                        <p>Lower integration costs, cutting OPEX significantly.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">25%</span>
                        <p>Faster analytics delivery, enabling quicker business decisions.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">0</span>
                        <p>Audit findings under NDMO, ensuring full regulatory compliance.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">35%</span>
                        <p>Built a scalable AI/ML foundation, future-proofing analytics capability.</p>
                    </div>
                </div>
            </section>

            {/* Other Case Studies */}
            <section className="cs-related container">
                <div className="cs-related-header">
                    <div className="purple-line-cs"></div>
                    <span className="cs-related-label">Case Studies</span>
                </div>
                <div className="cs-cards-grid">
                    {[
                        { title: "Modernizing Compliance & Reporting with Data at Scale", image: images.newcase2, to: "/case-studies/banking" },
                        { title: "Unified Data for Smarter Insurance Decisions", image: images.newcase3, to: "/case-studies/insurance" },
                        { title: "A Single Customer View for Better Airline Experiences", image: images.newcase4, to: "/case-studies/airline" },
                    ].map((s, i) => (
                        <div key={i} className="cs-card" onClick={() => handleLinkClick(s.to)} style={{ cursor: 'pointer' }}>
                            <div className="cs-card-img-wrap">
                                <img src={s.image} alt={s.title} />
                            </div>
                            <h3>{s.title}</h3>
                            <a href={s.to} className="cs-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(s.to); }}>Read More →</a>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default CaseStudy2;